import { useState } from "react";
import { ImageIcon } from "lucide-react";
import { useSite } from "@/context/SiteContext";
import { fileUrl } from "@/lib/api";

export const Gallery = () => {
  const { site, openLightbox } = useSite();
  const [filter, setFilter] = useState("all");
  const catName = Object.fromEntries(site.categories.map((c) => [c.id, c.name]));
  const photos = site.photos
    .filter((p) => filter === "all" || p.category_id === filter)
    .sort((a, b) => Number(b.featured) - Number(a.featured));
  return (
    <section id="dokumentasi" className="py-12 sm:py-16" data-testid="gallery-section">
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <p className="text-[11px] font-bold uppercase tracking-[0.14em] text-nanina-fresh">Dokumentasi</p>
        <h2 className="mt-1 text-2xl sm:text-3xl font-extrabold tracking-tight text-nanina-green">Momen layanan Nanina Care</h2>
        <p className="mt-2 text-sm text-nanina-muted max-w-lg">Foto aktivitas asli yang dipublikasikan dengan izin keluarga.</p>
        <div className="mt-5 flex gap-2 overflow-x-auto nn-scroll-x pb-2" role="tablist" aria-label="Filter dokumentasi">
          {[{ id: "all", name: "Semua", slug: "all" }, ...site.categories].map((c) => (
            <button key={c.id} role="tab" aria-selected={filter === c.id} onClick={() => setFilter(c.id)} className={`shrink-0 rounded-full px-3.5 py-1.5 text-xs font-semibold transition-colors ${filter === c.id ? "bg-nanina-green text-white" : "bg-white border border-nanina-line text-nanina-green hover:bg-nanina-skysoft"}`} data-testid={`gallery-filter-${c.slug}`}>
              {c.name}
            </button>
          ))}
        </div>
        {photos.length === 0 ? (
          <div className="mt-4 rounded-3xl border border-dashed border-[#C8DCD5] bg-white p-8 text-center text-sm text-nanina-muted" data-testid="gallery-empty">
            <ImageIcon className="h-7 w-7 mx-auto mb-2 text-nanina-sky" />
            Dokumentasi resmi untuk kategori ini akan ditampilkan setelah diunggah dan disetujui admin.
          </div>
        ) : (
          <div className="mt-4 grid grid-cols-2 md:grid-cols-4 auto-rows-[140px] sm:auto-rows-[180px] gap-2.5 sm:gap-3">
            {photos.map((p, i) => (
              <button key={p.id} onClick={() => openLightbox(photos, i)} className={`group relative overflow-hidden rounded-2xl bg-nanina-skysoft ${p.featured ? "col-span-2 row-span-2" : ""}`} data-testid={`gallery-photo-${p.id}`}>
                <img src={fileUrl(p.id)} alt={p.caption || "Dokumentasi Nanina Care"} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105" />
                <span className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent text-left text-white p-2.5">
                  <span className="block text-[10px] uppercase tracking-wider opacity-80">{catName[p.category_id]}</span>
                  {p.caption && <span className="block text-xs line-clamp-2">{p.caption}</span>}
                </span>
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};
